import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
  }

  .modal-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 1001;
    display: flex;
    flex-direction: column;
    max-width: 90%;
    max-height: 90%;
    width: 600px; /* Largura padrão */
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  h2 {
    margin: 0;
    font-size: 1.5rem;
    color: #2A2A29;
  }

  .close-button {
    background: none;
    border: none;
    font-size: 2rem;
    cursor: pointer;
    color: #666;

    &:hover {
      color: #333;
    }
  }
`;

export const CropContainer = styled.div`
  position: relative;
  width: 100%;
  height: 400px; /* Altura fixa para o cropper */
  background: #333;
  margin-bottom: 20px;

  .cropper-container {
    background: #333;
  }
  .cropper-media {
    object-fit: contain;
  }
`;

export const Controls = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  padding-top: 10px;

  label {
    font-weight: bold;
    color: #2A2A29;
  }

  .slider {
    width: 80%;
  }

  button {
    margin-top: 10px;
    width: 80%;
    padding: 10px;
    font-size: 1rem;
  }
`;
